import { Component, Input, OnInit, Optional } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/classes/organization';
import { ApiService } from 'src/app/services/api.service';
import { PublicSettingsService } from 'src/app/services/public-settings.service';

@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss'],
})
export class TncComponent implements OnInit {
  @Input() noClose = false
  @Input() showAccept = true
  tnc!: any

  constructor(
    @Optional() public activeModal: NgbActiveModal,
    private settingsService: PublicSettingsService, 
    private apiService: ApiService) { }

  ngOnInit() {
    this.settingsService.tnc(this.apiService.organizationId()).subscribe((tnc) => {
      this.tnc = tnc
    })
  }
}
